import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('return-stock/index', {params});
    },
    searchMaterial(params) {
        return Service().get('return-stock/search-material',  {params});
    },
    getMaterial(params) {
        return Service().get('return-stock/get-material', {params});
    },
    create(params) {
        return Service().post('return-stock/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('return-stock/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    updatStatus(id, params) {
        return Service().post('return-stock/update-status/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    updateDesc(id, params) {
        return Service().post('return-stock/update-description/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('return-stock/delete/'+id);
    },
}